import React, { useState } from 'react'
import Input from '../../components/common/Input';
import Modal from '../../components/common/Modal';

const StudentTransfers = () => {
    const [formData, setFormData] = useState({
        transferReason: "",
        transferDate: "",
        shortReason: "",
        detailedReason: "",
        notes: "",
        document: null,
    });

    const dues = [
        {
            feeType: "Activity Fee",
            amount: 700,
        },
        {
            feeType: "Academic Fee",
            amount: 14151,
        },
    ];

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        setFormData({
            ...formData,
            [name]: files ? files[0] : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    const handleClear = () => {
        setFormData({
            transferReason: "",
            transferDate: "",
            shortReason: "",
            detailedReason: "",
            notes: "",
            document: null,
        });
    };

    const totalDue = dues.reduce(
        (sum, item) => sum + item.amount,
        0
    );
    const [selectedStudent, setSelectedStudent] = useState(null);
    const handleEdit = (student) => {
        setSelectedStudent(student);
        setShowModal(true);
    };
    const [showModal, setShowModal] = useState(false);
    const [transfers, setTransfers] = useState([
        {
            id: 1,
            academic_year: "2026-2027",
            curriculam: "Fight",
            class: "1",
            section: "Vayu",
            roll_no: "100",
            student_name: "Raj",
            father_name: "Paandu",
            transfer_status: "Transfered",
        },
        {
            id: 2,
            academic_year: "2026-2027",
            curriculam: "Fight",
            class: "1",
            section: "Vayu",
            roll_no: "100",
            student_name: "Jeevan",
            father_name: "Paandu",
            transfer_status: "Active",
        },
        {
            id: 3,
            academic_year: "2026-2027",
            curriculam: "Fight",
            class: "1",
            section: "Bruvanth",
            roll_no: "100",
            student_name: "Raj",
            father_name: "Paandu",
            transfer_status: "Pending",
        }
    ]);



    return (
        <>
            {/* PAGE HEADER */}
            <div className="page-header">

                <div><h2>Transfers</h2></div>
                <button
                    className="btn btn-primary page-btn"
                    onClick={() => {

                        setShowModal(true);
                    }}
                >
                    <i className="lni lni-plus fw-bold fs-4 lh-0"></i>
                    Add Transfers
                </button>
            </div>

            <div className="card shadow-sm mt-3">
                <div className="card-header d-inline">
                    <div className="">
                        <div className='row'>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Academic Year"
                                    name="academic_year"
                                    // value={form.dob}
                                    // onChange={handleChange}
                                    options={[
                                        { value: '2025-2026', label: '2025-2026' },
                                        { value: '2026-2027', label: '2026-2027' },
                                    ]}
                                />
                            </div>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Curriculam"
                                    name="Curriculam"
                                    // value={form.Curriculam}
                                    // onChange={handleChange}
                                    options={[
                                        { value: 'ssc', label: 'SSC' },
                                        { value: 'cbsc', label: 'CBSC' },
                                    ]}
                                />
                            </div>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Class"
                                    name="class"
                                    // value={form.Curriculam}
                                    // onChange={handleChange}
                                    options={[
                                        { value: '1', label: '1' },
                                        { value: '2', label: '2' },
                                    ]}

                                />
                            </div>
                            <div className='col-md-3 col-sm-6'>
                                <Input
                                    label="Section"
                                    name="section"
                                    // value={form.Curriculam}
                                    // onChange={handleChange}
                                    options={[
                                        { value: 'a', label: 'A' },
                                        { value: 'b', label: 'B' },
                                    ]}

                                />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <table className="table table-bordered table-hover">
                        <thead className="">
                            <tr>
                                <th>Academic Year</th>
                                <th>Curriculam</th>
                                <th>Class</th>
                                <th>Section</th>
                                <th>Roll No.</th>
                                <th>Student</th>
                                <th>Father / Guardion Name</th>
                                <th>Status</th>
                                <th width="100">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                transfers.map(item => (
                                    <tr key={item.id}>
                                        <td>
                                            {item.academic_year}
                                        </td>
                                        <td>
                                            {item.curriculam}
                                        </td>
                                        <td>
                                            {item.class}
                                        </td>
                                        <td>
                                            {item.section}
                                        </td>
                                        <td>
                                            {item.roll_no}
                                        </td>
                                        <td>
                                            {item.student_name}
                                        </td>
                                        <td>
                                            {item.father_name}
                                        </td>
                                        <td>
                                            {item.transfer_status}
                                        </td>
                                        <td className=''>

                                            <button
                                                className={`btn btn-sm  d-flex 
                                                    ${item.transfer_status === "Transfered" ? "btn-danger" : "btn-outline-primary"}`}
                                                onClick={() => handleEdit(item)}
                                            >
                                                <i className="lni lni-refresh-user-1 fs-4 lh-0 me-2"></i> Transfer
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                {/* Custom Modal */}
                {
                    showModal && (
                        <Modal
                            show={showModal}
                            onClose={() => setShowModal(false)}
                            title={`Student Transfer ${selectedStudent
                                ? `- ${selectedStudent.student_name}`
                                : ""
                                }`}
                            size="lg"
                        >
                            <form onSubmit={handleSubmit}>

                                <div className="row">

                                    {/* Left Section */}
                                    <div className="col-lg-7">

                                        <div className="row">
                                            <div className="col-md-6">
                                                <Input
                                                    label="From Date"
                                                    name="transferDate"
                                                    type="date"
                                                    value={formData.transferDate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <Input
                                                    label="Reason"
                                                    name="transferReason"
                                                    value={formData.transferReason}
                                                    onChange={handleChange}
                                                    options={[
                                                        {
                                                            value: "parent_request",
                                                            label: "Parent Request"
                                                        },
                                                        {
                                                            value: "relocation",
                                                            label: "Relocation"
                                                        },
                                                        {
                                                            value: "school_change",
                                                            label: "School Change"
                                                        },
                                                        {
                                                            value: "academic",
                                                            label: "Academic Reasons"
                                                        },
                                                        {
                                                            value: "other",
                                                            label: "Others"
                                                        }
                                                    ]}
                                                />
                                            </div>

                                           

                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">
                                                Short Reason
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="2"
                                                name="shortReason"
                                                value={formData.shortReason}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">
                                                Detailed Reason
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="5"
                                                name="detailedReason"
                                                value={formData.detailedReason}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">
                                                Notes / Formalities
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="5"
                                                name="notes"
                                                value={formData.notes}
                                                onChange={handleChange}
                                            />
                                        </div>

                                    </div>

                                    {/* Right Section */}
                                    <div className="col-lg-5">

                                        <div className="mb-3">
                                            <label className="form-label">
                                                Supporting Documents
                                            </label>

                                            <input
                                                type="file"
                                                name="document"
                                                className="form-control"
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="card shadow-sm">

                                            <div className="card-header bg-primary text-white">
                                                Pending Dues
                                            </div>

                                            <div className="table-responsive">

                                                <table className="table table-bordered table-sm mb-0">

                                                    <thead>
                                                        <tr>
                                                            <th>Fee Type</th>
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {dues.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.feeType}</td>
                                                                <td>
                                                                    ₹ {item.amount}
                                                                </td>
                                                            </tr>
                                                        ))}

                                                        <tr className="table-warning fw-bold">
                                                            <td>Total</td>
                                                            <td>
                                                                ₹ {totalDue}
                                                            </td>
                                                        </tr>

                                                    </tbody>

                                                </table>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div className="text-end mt-4">
                                  

                                    <button
                                        type="button"
                                        className="btn btn-secondary me-2"
                                        onClick={handleClear}
                                    >
                                        Clear
                                    </button>
                                      <button
                                        type="submit"
                                        className="btn btn-primary me-2"
                                    >
                                        Save
                                    </button>

                                    {/* <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => setShowModal(false)}
                                    >
                                        Close
                                    </button> */}

                                </div>

                            </form>
                        </Modal>
                    )
                }
            </div>
        </>
    )
}

export default StudentTransfers